import ApexCharts from 'apexcharts';

$(window).on('load', function(){
    if($('mimas-block[block-name="infographics"]').length) {
        let graphs = $('mimas-block[block-name="infographics"]').find('.infographic__chart');

        graphs.each(function() {
            let $this = $(this);

            let style_settings = {
                font_family: 'proxima-nova,Helvetica,Arial,sans-serif',
                primary_color: '#5525e5',
                secondary_colour: '#4b4b4b',
                base_colour: '#000000',
                gray_colour: '#F7F7F7'
            }

            let graph_settings = {
                chart: {
                    type: 'area',
                    height: $this.data('height'),
                    width: '100%',
                    toolbar: {
                        show: false
                        ,
                    },
                    zoom: {
                        enabled: false
                    },
                },
                colors: [style_settings.primary_color],
                fill: {
                    colors: [style_settings.primary_color],
                },
                stroke: {
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: [style_settings.base_colour]
                    },
                    background: {
                        enabled: false,
                    },
                    offsetY: -20,
                    formatter: (data) => {
                        return ($this.data('info-reverse') == '1') ? 500 - data : data;
                    }
                },
                series: [{
                    name: 'Ranking',
                    data: $this.data('info-value')
                }],
                title: {
                    text: undefined
                },
                xaxis: {
                    categories: $this.data('info-label'),
                    labels: {
                        fontSize: '12px',
                        fontFamily: style_settings.font_family,
                        color: [style_settings.secondary_colour]
                    }
                },
                yaxis: {
                    opposite: true,
                    labels: {
                        show: false,
                        formatter: (data) => {
                            return ($this.data('info-reverse') == '1') ? 500 - data : data;
                        }
                    }
                },
                grid: {
                    padding: {
                        top: 10
                    }
                }
            }

            let chart = new ApexCharts(this, graph_settings);

            chart.render();
        });
    }
});